import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import styles from 'styles';
import moment from 'moment';
import BasicChip from '../../Base/Chips/BasicChip';
import _ from 'lodash';
import DataFillRatioPopover from './DataFillRatioPopover';

const getFillRatioColor = (counter, total) => {
    if (counter === total) return 'green';
    if (counter < 3) return 'red';
    if (counter >= 3 && counter < total) return 'yellow';
    return 'yellow';
};

function VesselListRow(props) {
    const { item } = props;
    const { modifiedFields } = item;

    let fields = [];
    if (modifiedFields) {
        fields = modifiedFields.map(i => i.updatedField);
    }

    const showModifiedFields = () => (
        <TableRowColumn style={styles.tableRowColumnModifed}>
            <p>
                {fields.includes('typeByConstruction') ? 'Type by construction' : null} <br />
                {fields.includes('geared') ? 'Geared' : null} <br />
                {fields.includes('deadWeight.sTpc') ? 'TPC' : null} <br />
                {fields.includes('grabbed') ? 'Grab fitted' : null} <br />
                {fields.includes('registerClass') ? 'Register class' : null}<br />
            </p>
        </TableRowColumn>
    );

    let gears = item.gearV2All ? item.gearV2All.join(', ') : null;
    if (!gears && item.geared) {
        gears = 'Geared';
    }

    /**
     * @returns {{counter: number, total: number, color: 'green' | 'yellow' | 'red', details: Array<{label: string, ok: boolean}>}}
     */
    const getDataFillRatio = () => {
        const data = {
            gear: _.get(item, 'gearV2.summary.0.type'),
            grab: _.get(item, 'grabV2.summary.0.type'),
            pumpsBallast: _.get(item, 'pumps.ballast.0.type'),
            pumpsCargo: _.get(item, 'pumps.cargo.0.type'),
            capacityGrain: _.get(item, 'capacity.grain'),
            capacityBale: _.get(item, 'capacity.bale'),
            capacityTankerSegregation: _.get(item, 'capacityTanker.segregation'),
            capacityTankerCargoCapacity: _.get(item, 'capacityTanker.cargoCapacity'),
            holdsQuantity: _.get(item, 'holds.quantity'),
            hatchesQuantity: _.get(item, 'hatches.quantity'),
            speedConsumption: item.speedConsumptionV2.length > 0
                && item.speedConsumptionV2.find(i => i.mode === 'Laden' && i.speed),
            owner: _.get(item, 'owner'),
        };

        /** @type {Array<{ key: string, label: string, tankOnly?: boolean }>} */
        const fields = [
            { key: 'gear', label: 'Gear' },
            { key: 'grab', label: 'Grab' },
            { key: 'pumpsBallast', label: 'Pumps (Ballast)' },
            { key: 'pumpsCargo', label: 'Pumps (Cargo)' },
            { key: 'capacityGrain', label: 'Capacity (Grain)' },
            { key: 'capacityBale', label: 'Capacity (Bale)' },
            { key: 'capacityTankerSegregation', label: 'Tanker Capacity (Segregation)', tankOnly: true },
            { key: 'capacityTankerCargoCapacity', label: 'Tanker Capacity (Cargo Capacity)', tankOnly: true },
            { key: 'holdsQuantity', label: 'Holds Quantity' },
            { key: 'hatchesQuantity', label: 'Hatches Quantity' },
            { key: 'speedConsumption', label: 'Speed & Consumption (Laden)' },
            { key: 'owner', label: 'Owner' },
        ];

        const isTank = item.typeByPurpose === 'TANK';
        const applicable = fields.filter(f => !f.tankOnly || isTank);

        const details = applicable.map(f => ({ label: f.label, ok: !!data[f.key] }));
        const counter = details.filter(d => d.ok).length;
        const total = applicable.length;

        return {
            counter, total, color: getFillRatioColor(counter, total), details, 
        };
    };

    const {
        counter, total, color, details, 
    } = getDataFillRatio();

    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const handlePopoverOpen = e => setPopoverAnchor(e.currentTarget);
    const handlePopoverClose = () => setPopoverAnchor(null);

    return (
        <TableRow>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.imoNumber}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.name}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.blt}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.typeByPurpose}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnCSS, textAlign: 'center' }}>{(item.registerClass && item.registerClass.name) || item.class || '-'}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnCSS, textAlign: 'center' }}>{gears}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.capacity && `${item.capacity.grain || '-'} / ${item.capacity.bale || '-'}`}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>{item.dw && item.dw.summer}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnModifed, textAlign: 'center' }}>{showModifiedFields()}</TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnModifed, textAlign: 'center' }}>
                {item.rt && (
                    <div className='text-center'>{item.rt.countryName}<br />{moment(item.rt.enteredAt).format('DD-MM-YYYY')}</div>
                )}
            </TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnModifed, textAlign: 'center' }}>
                <div
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}
                    style={{ display: 'inline-block' }}
                >
                    <BasicChip
                        label={`${counter}/${total}`}
                        variant="outlined"
                        color={color}
                        style={{ width: 'fit-content', display: 'block', margin: '0 auto' }}
                    />
                </div>
                <DataFillRatioPopover
                    open={!!popoverAnchor}
                    anchorEl={popoverAnchor}
                    onClose={handlePopoverClose}
                    details={details}
                    counter={counter}
                    total={total}
                />
            </TableRowColumn>
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, textAlign: 'center' }}>
                <RaisedButton label='Edit' primary containerElement={<Link to={`/vessels/${item._id}`} />} />
            </TableRowColumn>
        </TableRow>
    );
}

export default connect(
    (state, { item }) => ({
        item,
    }),
    dispatch => bindActionCreators(
        {
        },
        dispatch,
    ),
)(VesselListRow);



// WEBPACK FOOTER //
// ./app/components/Vessels/List/Row.jsx